import React, { FC, useState } from 'react';
import styles from './Tabs.module.css';
import { useThemes } from '@hooks/useThemes';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';

export interface TabsProps {
    classes?: string;
    tabs: { label: string | JSX.Element; content: string | JSX.Element; disabled?: boolean }[];
}

export const Tabs: FC<TabsProps> = ({ classes, tabs }) => {
    const { useGrayscaleTheme } = useThemes();

    const [active, setActive] = useState<number>(0);

    return (
        <div className={`tabs ${useGrayscaleTheme ? styles['theme-grayscale'] : ''} ${classes || ''}`} data-testid="tabs">
            <ul className="nav" role="tablist">
                {tabs.map((item, index) => {
                    const isActive = index === active;

                    return (
                        <li key={`tab-${index}`} className="nav-item" role="presentation">
                            <button
                                type="button"
                                role="tab"
                                className={`nav-link ${styles['nav-link']} ${isActive ? styles.active : ''}`}
                                aria-selected={isActive ? 'true' : 'false'}
                                disabled={item.disabled || false}
                                onClick={() => setActive(index)}>
                                <Typography fontWeight={isActive ? '800' : '400'} tagVariant={TypographyTagVariants.span}>
                                    {item.label}
                                </Typography>
                            </button>
                        </li>
                    );
                })}
            </ul>
            <div className={`tab-content ${styles['tab-content']} pt-4 border-top`}>
                {tabs.map((item, index) => (
                    <div
                        key={`tab-content-${index}`}
                        role="tabpanel"
                        tabIndex={index}
                        className={`tab-pane ${styles['tab-pane']} fade ${index === active ? 'show active' : ''}`}>
                        <Typography tagVariant={TypographyTagVariants.span}>
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {item.content}
                            </div>
                        </Typography>
                    </div>
                ))}
            </div>
        </div>
    );
};
